import { render, staticRenderFns } from "./DynamicConfirmation.vue?vue&type=template&id=6320f7a7&"
import script from "./DynamicConfirmation.ts?vue&type=script&lang=ts&"
export * from "./DynamicConfirmation.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports